var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home" },
    [
      _c(
        "div",
        [
          _c(
            "a-select",
            {
              staticClass: "select",
              class: [_vm.lang],
              staticStyle: { width: "440px", "margin-right": "5px" },
              attrs: { size: "large", placeholder: _vm.$t("inputLinkAccount") },
              on: { change: _vm.handleChange },
              model: {
                value: _vm.linkedin_email,
                callback: function ($$v) {
                  _vm.linkedin_email = $$v
                },
                expression: "linkedin_email",
              },
            },
            [
              _c(
                "a-select-option",
                { class: [_vm.lang], attrs: { value: "" } },
                [_vm._v(_vm._s(_vm.$t("inputLinkAccount")))]
              ),
              _vm._l(_vm.linkList, function (item, index) {
                return _c(
                  "a-select-option",
                  {
                    key: index,
                    class: [_vm.lang],
                    attrs: { value: item.linkedin_id },
                  },
                  [_vm._v(" " + _vm._s(item.linkedin_email) + " ")]
                )
              }),
            ],
            2
          ),
          _c(
            "a-button",
            {
              class: [_vm.lang],
              attrs: { type: "primary", size: "large", id: "salse-create-btn" },
              on: { click: _vm.createCampaign },
            },
            [_vm._v(" " + _vm._s(_vm.$t("Create")) + " ")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "wrap-table", staticStyle: { "min-height": "650px" } },
        [
          _c("ul", { staticClass: "nav" }, [
            _c(
              "li",
              {
                staticClass: "left",
                class: { active: _vm.leftActive },
                on: {
                  click: function ($event) {
                    return _vm.tabHandler("left")
                  },
                },
              },
              [
                _c("span", { class: [_vm.lang] }, [
                  _vm._v(_vm._s(_vm.$t("Active"))),
                ]),
              ]
            ),
            _c(
              "li",
              {
                staticClass: "right",
                class: { active: _vm.rightActive },
                on: {
                  click: function ($event) {
                    return _vm.tabHandler("right")
                  },
                },
              },
              [
                _c("span", { class: [_vm.lang] }, [
                  _vm._v(" " + _vm._s(_vm.$t("Paused")) + " "),
                ]),
              ]
            ),
          ]),
          _c("a-table", {
            staticClass: "custom-scrollbar capinTable",
            class: { arTable: _vm.lang == "AR" ? true : false },
            attrs: {
              scroll: {
                x: 1120,
              },
              size: "middle",
              columns: _vm.columns,
              rowKey: (record, index) => index,
              "data-source": _vm.tableData,
              pagination: false,
              loading: _vm.loading,
              locale: { emptyText: _vm.$t("noCamp") },
              "row-class-name": (_record, index) =>
                index % 2 !== 1 ? "table-bg" : null,
            },
            scopedSlots: _vm._u([
              {
                key: "ProspectiveClients",
                fn: function (text, record) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "skipDetail",
                        on: {
                          click: function ($event) {
                            return _vm.goDetail(record, "")
                          },
                        },
                      },
                      [_vm._v(_vm._s(record.customer_find))]
                    ),
                  ]
                },
              },
              {
                key: "connectionsRequest",
                fn: function (text, record) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "skipDetail",
                        on: {
                          click: function ($event) {
                            return _vm.goDetail(record, "1")
                          },
                        },
                      },
                      [_vm._v(_vm._s(record.connections_request))]
                    ),
                  ]
                },
              },
              {
                key: "ConnectionsMade",
                fn: function (text, record) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "skipDetail",
                        on: {
                          click: function ($event) {
                            return _vm.goDetail(record, "2")
                          },
                        },
                      },
                      [_vm._v(_vm._s(record.connections_made))]
                    ),
                  ]
                },
              },
              {
                key: "NumberOfGreeters",
                fn: function (text, record) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "skipDetail",
                        on: {
                          click: function ($event) {
                            return _vm.goDetail(record, "2")
                          },
                        },
                      },
                      [_vm._v(_vm._s(record.greeting_count))]
                    ),
                  ]
                },
              },
              {
                key: "replies",
                fn: function (text, record) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "skipDetail",
                        on: {
                          click: function ($event) {
                            return _vm.goDetail(record, "4")
                          },
                        },
                      },
                      [_vm._v(_vm._s(record.replies))]
                    ),
                  ]
                },
              },
              {
                key: "status",
                fn: function (text, record) {
                  return [
                    _c(
                      "div",
                      {
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                          },
                        },
                      },
                      [
                        _c("a-switch", {
                          attrs: { size: "small" },
                          on: {
                            change: function ($event) {
                              return _vm.onChangeRecord(record)
                            },
                          },
                          nativeOn: {
                            click: function ($event) {
                              $event.stopPropagation()
                            },
                          },
                          model: {
                            value: record.status,
                            callback: function ($$v) {
                              _vm.$set(record, "status", $$v)
                            },
                            expression: "record.status",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "campaign_name",
                fn: function (text, record) {
                  return [
                    _vm._v(" " + _vm._s(record.campaign_name) + " "),
                    record && record.action_log
                      ? _c("CampaignTableTip", {
                          attrs: {
                            record: record.action_log,
                            lable: "click_history_records",
                            event: "campaign",
                            method: "sales",
                          },
                        })
                      : _vm._e(),
                  ]
                },
              },
              {
                key: "linkedin_email",
                fn: function (text, record) {
                  return [
                    record.is_not_friend
                      ? _c(
                          "a-tooltip",
                          { attrs: { placement: "bottom" } },
                          [
                            _c("template", { slot: "title" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("baibanCampaignTipTxt"))),
                              ]),
                            ]),
                            _c("a-icon", {
                              staticClass: "linkedin_email_warning",
                              attrs: { type: "exclamation-circle" },
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" " + _vm._s(record.linkedin_email) + " "),
                  ]
                },
              },
              {
                key: "action",
                fn: function (text, record) {
                  return [
                    _c(
                      "a-dropdown",
                      {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "overlay",
                              fn: function () {
                                return [
                                  _c(
                                    "a-menu",
                                    [
                                      _c(
                                        "a-menu-item",
                                        {
                                          key: "0",
                                          on: {
                                            click: function ($event) {
                                              return _vm.goEdit(record)
                                            },
                                          },
                                        },
                                        [
                                          _c("a-icon", {
                                            attrs: { type: "form" },
                                          }),
                                          _c("span", { class: [_vm.lang] }, [
                                            _vm._v(
                                              _vm._s(_vm.$t("campaignEdit"))
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-menu-item",
                                        {
                                          key: "1",
                                          on: {
                                            click: function ($event) {
                                              return _vm.goDetail(record)
                                            },
                                          },
                                        },
                                        [
                                          _c("a-icon", {
                                            attrs: { type: "edit" },
                                          }),
                                          _c("span", { class: [_vm.lang] }, [
                                            _vm._v(_vm._s(_vm.$t("Details"))),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-menu-item",
                                        {
                                          key: "2",
                                          on: {
                                            click: function ($event) {
                                              return _vm.copyHandler(record)
                                            },
                                          },
                                        },
                                        [
                                          _c("a-icon", {
                                            attrs: { type: "copy" },
                                          }),
                                          _c("span", { class: [_vm.lang] }, [
                                            _vm._v(_vm._s(_vm.$t("Copy"))),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-menu-item",
                                        {
                                          key: "3",
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteHandler(record)
                                            },
                                          },
                                        },
                                        [
                                          _c("a-icon", {
                                            attrs: { type: "delete" },
                                          }),
                                          _c("span", { class: [_vm.lang] }, [
                                            _vm._v(_vm._s(_vm.$t("Delete"))),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _c(
                          "a-button",
                          {
                            staticStyle: { padding: "0 8px" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                            },
                          },
                          [
                            _c("span", { class: [_vm.lang] }, [
                              _vm._v(_vm._s(_vm.$t("Action"))),
                            ]),
                            _c("a-icon", { attrs: { type: "down" } }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c(
            "div",
            [
              _c("app-footer", {
                attrs: {
                  current: _vm.page,
                  pageSize: _vm.pageSize,
                  total: _vm.total,
                },
                on: {
                  onPageChange: _vm.onPageChange,
                  onPageSizeChange: _vm.onPageSizeChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showModal
        ? _c("CampaignModalCon", {
            attrs: { showModal: _vm.showModal, newLinkedIn: _vm.newLinkedIn },
            on: {
              "update:showModal": function ($event) {
                _vm.showModal = $event
              },
              "update:show-modal": function ($event) {
                _vm.showModal = $event
              },
              saveLinkedIn: _vm.saveLinkedIn,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }